import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "12",
  viewBox: "0 0 8 12",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2.54081 6.0001L6.90252 1.67474C7.19656 1.38315 7.19656 0.910384 6.90252 0.618793C6.60847 0.327201 6.13174 0.327201 5.8377 0.618792L0.943579 5.47212C0.649537 5.76372 0.649537 6.23648 0.943579 6.52807L5.8377 11.3814C6.13174 11.673 6.60847 11.673 6.90252 11.3814C7.19656 11.0898 7.19656 10.617 6.90252 10.3255L2.54081 6.0001Z",
  fill: "#86899E"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }